import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CreateNewsDto, News, SearchNewsDto, UpdateNewsDto } from 'src/typings';
import { CurrentUserService as UserService } from '../user/user.service';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  constructor(private userService: UserService, private http: HttpClient) {}

  async uploadImage(file: File) {
    const imageName = await firstValueFrom(this.userService.uploadFile(file));
    return imageName.name;
  }

  create(payload: CreateNewsDto) {
    return this.http.post<News>(`${environment.BACKEND}/news/create`, payload).pipe(
      map((row: News) => {
        row.date = new Date(row.date);
        return row;
      })
    );
  }

  update(payload: UpdateNewsDto) {
    return this.http.put<News>(`${environment.BACKEND}/news/update`, payload).pipe(
      map((row: News) => {
        row.date = new Date(row.date);
        return row;
      })
    );
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/news/${id}`);
  }

  search(payload?: SearchNewsDto) {
    return this.http.post<{ count: number; data: News[] }>(
      `${environment.BACKEND}/news/search`,
      payload || {}
    ).pipe(
      map((result) => ({
        ...result,
        data: result.data.map((row) => ({ ...row, date: new Date(row.date) }))
      }))
    );
  }

  getOne(id: number) {
    return this.http.get<News>(`${environment.BACKEND}/news/${id}`).pipe(
      map((row: News) => {
        row.date = new Date(row.date);
        return row;
      })
    );
  }

  generateImage(payload: { title: string; text: string }) {
    return this.http.post<{ img: string }>(`${environment.BACKEND}/news/generate-image`, payload);
  }
}
